import { atom, selector, selectorFamily } from 'recoil';
import { ITagifyItem } from '../Forms/Fields/ContentEditableTextarea2';

export const tagifyOptionsAtom = atom<ITagifyItem[]>({
  key: 'tagifyOptions',
  default: [],
});
export const rideOwnershipValueAtom = atom<string>({
  key: 'rideOwnershipValue',
  default: 'own',
});
export const ridePrivacyValueAtom = atom<string>({
  key: 'ridePrivacyValue',
  default: 'public',
});
